import React from "react";
import { Heading } from "spectacle";

export const S30 = () => <Heading size={1}>Let's talk about problems</Heading>;
